import { computed, Directive, inject, InjectionToken, input, type Provider } from '@angular/core';

export interface CommonImgConfig {
	srcConverterProvider: () => (src: string) => string;
}

const defaultCommonImgConfig: CommonImgConfig = {
	srcConverterProvider: () => {
		return (src: string) => src;
	},
};

export const COMMON_IMG_CONFIG = new InjectionToken<CommonImgConfig>('COMMON_IMG_CONFIG');

export const provideCommonImgConfig = (config: Partial<CommonImgConfig>): Provider => {
	return {
		provide: COMMON_IMG_CONFIG,
		useValue: {
			...defaultCommonImgConfig,
			...config,
		},
	};
};

export const injectSrcConverter = (): ((src: string) => string) => {
	const config = inject(COMMON_IMG_CONFIG, { optional: true }) || defaultCommonImgConfig;
	return config.srcConverterProvider();
};

@Directive({
	selector: 'img',
	standalone: true,
	host: {
		'[src]': '$src()',
	},
})
export class CommonImgDirective {
	private readonly config =
		inject(COMMON_IMG_CONFIG, { optional: true }) || defaultCommonImgConfig;

	private readonly srcConverter = this.config.srcConverterProvider();

	public readonly $originalSrc = input.required<string | null | undefined>({ alias: 'src' });

	public readonly $src = computed(() => {
		const src = this.$originalSrc();
		return src ? this.srcConverter(src) : src;
	});
}
